// ./components/Select.ts
import { ComponentStyleConfig } from '@chakra-ui/react';

// native Chakra <Select>
export const Select: ComponentStyleConfig = {
  variants: {
    outline: {
      field: {
        bg: 'white',
      },
    },
  },
};

// chakra-react-select (<Select> from @netiva/classifieds-ui). Its styles are passed
// through the chakra theming context as a ChakraStylesConfig, see classifieds-ui theme/components/Select.ts.
export const ReactSelect: ComponentStyleConfig = {
  baseStyle: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: (provided: any) => ({ ...provided, background: 'white' }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any,
};
